module.exports = __webpack_public_path__ + "assets/images/gcrc-df02ae3a37dffabb07050f94e6f92ed9.png";